import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { AlertCenter } from './AlertCenter'
import { MainSidebar } from './MainSidebar'

export function MainLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(
    localStorage.getItem('isSidebarCollapsed') === 'true' || false
  )

  React.useEffect(() => {
    // TODO: use a better way to store this
    localStorage.setItem('isSidebarCollapsed', isSidebarCollapsed.toString())
  }, [isSidebarCollapsed])

  return (
    <div className="flex h-screen bg-white-50 overflow-hidden">
      <MainSidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <main className="flex-1 overflow-y-auto py-6">
        <Outlet />
      </main>
      <AlertCenter />
    </div>
  )
}
